<div class="edit-container">
  <h1 class="edit-title">Actualizare departament</h1>
  <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Nume departament</mat-label>
        <input type="text" matInput formControlName="name" />
        <mat-error
          *ngIf="!form.controls['name'].valid && form.controls['name'].touched"
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="edit-field">
      <mat-form-field appearance="fill">
        <mat-label>Descriere departament</mat-label>
        <input type="text" matInput formControlName="description" />
        <mat-error
          *ngIf="
            !form.controls['description'].valid &&
            form.controls['description'].touched
          "
        >
          Câmp obligatoriu
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
    <div class="edit-action-btns">
      <button
        class="buttons"
        type="button"
        mat-flat-button
        (click)="closeDialog()"
      >
        Close
      </button>
      <button class="buttons" type="submit" mat-flat-button color="primary">
        Save
      </button>
    </div>
  </form>
</div>
